import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedFlex,
  ExtendedBox,
  Image,
  Link,
} from '../../coreui';

import webinarIcon from '../../assets/icon_webinar.svg';
import WebinarModal from '../../privatePlacement/components/WebinarModal';

class Webinar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalVisible: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState({
      isModalVisible: !this.state.isModalVisible,
    });
  }

  render() {
    const {
      webinar,
      comingSoon,
      handleClick,
      ...passedProps
    } = this.props;

    const {
      isModalVisible,
    } = this.state;

    if (!webinar && !comingSoon) {
      return null;
    }

    return (
      <ExtendedFlex
        flexBasis="100%"
        bg="gray.1"
        p={15}
        textAlign="center"
        my={[5, 5, 30]}
        mx={10}
        name="webinar"
        {...passedProps}
      >
        <ExtendedBox
          textAlign="center"
        >
          <Image
            src={webinarIcon}
            mr={10}
            height="20px"
            position="relative"
            top="4px"
            display="inline-block"
          />
          { comingSoon &&
            <Link
              onClick={() => { return null; }}
              type="L4"
              lineHeight="26px"
              style={{ cursor: 'default' }}
            >
              Webinar Coming Soon
            </Link>
          }
          { (!comingSoon && webinar) &&
            <React.Fragment>
              <Link
                onClick={!handleClick ? this.toggleModal : handleClick}
                type="L4"
                lineHeight="26px"
              >
                View The Webinar
              </Link>
              {
                !handleClick &&
                <WebinarModal
                  isVisible={this.state.isModalVisible}
                  handleClick={this.toggleModal}
                  url={webinar}
                  playing={isModalVisible}
                />
              }
            </React.Fragment>
          }
        </ExtendedBox>
      </ExtendedFlex>
    );
  }
}

Webinar.propTypes = {
  webinar: PropTypes.string,
  comingSoon: PropTypes.bool,
  handleClick: PropTypes.func,
};

export default Webinar;
